import React from 'react';
import Helmet from 'react-helmet';
import { graphql, useStaticQuery, Link } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import RelatedLinks from '../components/RelatedLinks';

const InformationPage = () => {
  const data = useStaticQuery(graphql`
    query InformationArticlesQuery {
      allInformationArticlesJson {
        edges {
          node {
            title
            summary
            type
            url
            slug
            image
          }
        }
      }
    }
  `);

  const articles = data.allInformationArticlesJson.edges.map(({ node }) => node);

  return (
    <Layout>
      <SEO
        title="宠物行业资讯 - 魔鬼鱼订货平台"
        description="魔鬼鱼订货平台信息发布，为您提供宠物行业最新的交易规则、零售攻略、品牌资讯、营销活动等干货内容，助力宠物门店业绩增长。"
        path="/information"
      />
      <Helmet>
        <meta
          name="keywords"
          content="魔鬼鱼订货平台, 信息发布, 宠物行业资讯, 宠物店零售, 宠物品牌, 交易规则, 魔鬼鱼沙龙"
        />
        <script type="application/ld+json" key="breadcrumb">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.mantas.cn'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '信息发布',
                item: 'https://www.mantas.cn/information'
              }
            ]
          })}
        </script>
        <script type="application/ld+json" key="itemlist">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            name: '宠物行业资讯',
            itemListElement: articles.map((article, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: article.title,
              url: article.type === 'internal' ? `https://www.mantas.cn${article.slug}` : article.url
            }))
          })}
        </script>
        <script type="application/ld+json" key="webpage">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            '@id': 'https://www.mantas.cn/information',
            name: '信息发布',
            url: 'https://www.mantas.cn/information',
            description: '魔鬼鱼订货平台信息发布，为您提供宠物行业最新的交易规则、零售攻略、品牌资讯',
            specialty: 'News'
          })}
        </script>
      </Helmet>

      <section className="information-page">
        <div className="information-container">
          <header className="information-header">
            <h1 className="information-title">信息发布</h1>
            <p className="information-subtitle">为您提供最新的行业资讯、交易规则与营销活动</p>
          </header>

          <div className="information-articles">
            {articles.map((article, index) => (
              <article key={index} className="information-article-card">
                {article.type === 'internal' ? (
                  <Link to={article.slug} className="information-article-link">
                    <div className="information-article-image-wrapper">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="information-article-image"
                        loading="lazy"
                      />
                    </div>
                    <div className="information-article-content">
                      <h2 className="information-article-title">{article.title}</h2>
                      <p className="information-article-summary">{article.summary}</p>
                      <span className="information-article-read-more">阅读全文 ›</span>
                    </div>
                  </Link>
                ) : (
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="information-article-link"
                  >
                    <div className="information-article-image-wrapper">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="information-article-image"
                        loading="lazy"
                      />
                    </div>
                    <div className="information-article-content">
                      <h2 className="information-article-title">{article.title}</h2>
                      <p className="information-article-summary">{article.summary}</p>
                      <span className="information-article-read-more">阅读全文 ›</span>
                    </div>
                  </a>
                )}
              </article>
            ))}
          </div>
        </div>

        {/* 站内互链（GEO 延伸阅读） */}
        <RelatedLinks
          title="延伸阅读"
          links={[
            { label: '供应商入驻', to: '/supplier' },
            { label: '注册指南', to: '/registration-guide/' },
            { label: '帮助中心', to: '/help' },
          ]}
        />
      </section>
    </Layout>
  );
};

export default InformationPage;